<template>
  <a-drawer
    width="50%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>订单详情</b>
    </a-divider>

    <div class="order-info">
      <table>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card
              :bordered="false"
              title="订单信息"
              :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
              :bodyStyle="{'background-color':'#fbfbfb'}"
            >
              <table class="info-table">
                <tr>
                  <td class="first">订单编号：</td>
                  <td class="data">{{ record.id }}</td>
                  <td class="first">订单状态：</td>
                  <td class="data">{{ record.orderStatusName }}</td>
                  <td class="first"></td>
                  <td class="data"></td>
                </tr>
                <tr>
                  <td class="first">下单时间：</td>
                  <td class="data">{{ record.createTime }}</td>
                  <td class="first"></td>
                  <td class="data"></td>
                  <td class="first"></td>
                  <td class="data"></td>
                </tr>
                <tr>
                  <td class="first">支付时间：</td>
                  <td class="data">{{ record.payTime || '-' }}</td>
                  <td class="first">支付方式：</td>
                  <td class="data">{{ record.payTypeName || '-' }}</td>
                  <td class="first">订单来源：</td>
                  <td class="data">{{ record.sourceName || '-' }}</td>
                </tr>
                <tr>
                  <td class="first">订单金额：</td>
                  <td class="data">¥{{ record.orderAmount ? Number(record.orderAmount).toFixed(2) : '0.00' }}</td>
                  <td class="first">商品金额：</td>
                  <td class="data">¥{{ record.goodsAmount ? Number(record.goodsAmount).toFixed(2) : '0.00' }}</td>
                  <td class="first">商品数量：</td>
                  <td class="data">{{ record.goodsCount }}</td>
                </tr>
                <tr>
                  <td class="first">实付金额：</td>
                  <td class="data">¥{{ record.payAmount ? Number(record.payAmount).toFixed(2) : '0.00' }}</td>
                  <td class="first">买家名称：</td>
                  <td class="data">{{ record.buyerName }}</td>
                  <td class="first">店铺名称：</td>
                  <td class="data">{{ record.shopName || '-' }}</td>
                </tr>
                <tr>
                  <td class="first">售后金额：</td>
                  <td class="data">¥{{ record.refundAmount ? Number(record.refundAmount).toFixed(2) : '0.00' }}</td>
                  <td class="first">会员折扣：</td>
                  <td class="data" style="color: #ff4d4f;">-¥{{ record.plusDiscount ? Number(record.plusDiscount).toFixed(2) : '0.00' }}</td>
                  <td class="first">优惠券减免：</td>
                  <td class="data" style="color: #ff4d4f;">-¥{{ record.couponMoney ? Number(record.couponMoney).toFixed(2) : '0.00' }}</td>
                </tr>
                <tr>
                  <td class="first">积分抵扣金额：</td>
                  <td class="data" style="color: #ff4d4f;">-¥{{ record.pointDeductionAmount ? Number(record.pointDeductionAmount).toFixed(2) : '0.00' }}</td>
                  <td class="first">使用积分数量：</td>
                  <td class="data">{{ record.pointDeductionNum ? Number(record.pointDeductionNum).toFixed(0) : '0' }} 积分</td>
                  <td class="first">余额支付：</td>
                  <td class="data" style="color: #52c41a;">¥{{ record.balanceAmount ? Number(record.balanceAmount).toFixed(2) : '0.00' }}</td>
                </tr>
                <tr>
                  <td class="first">付款方式：</td>
                  <td class="data">{{ record.payTypeName || '-' }}</td>
                  <td class="first">{{ (record.payTypeName || '其他付款') }}支付：</td>
                  <td class="data">¥{{ (Number(record.payAmount || 0) - Number(record.balanceAmount || 0)).toFixed(2) }}</td>
                  <td class="first"></td>
                  <td class="data"></td>
                </tr>
                <tr>
                  <td class="first">用户备注：</td>
                  <td colspan="5">{{ record.buyerMessage || '-' }}</td>
                </tr>
                <tr>
                  <td class="first">后台备注：</td>
                  <td colspan="5">{{ record.adminRemark || '-' }}</td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card
              :bordered="false"
              title="商品信息"
              :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
              :bodyStyle="{'background-color':'#fbfbfb'}"
            >
              <a-table
                :bordered="false"
                :pagination="false"
                :columns="goodsColumns"
                rowKey="goodsId"
                :data-source="record.orderItemList"
              >
                <template slot="picture" slot-scope="text">
                  <div>
                    <img
                      v-if="text"
                      :src="text"
                      style="width:60px;height:62px;"
                      @click="handleRecordPreview(text)"
                      alt="none"
                    />
                  </div>
                </template>
                <template slot="refundStatus" slot-scope="text">
                  <a-tag v-if="text && text > 0" :color="getRefundStatusColor(text)">{{ getRefundStatusName(text) }}</a-tag>
                  <span v-else>-</span>
                </template>
                <template slot="refundAmount" slot-scope="text">
                  <span style="color: #ff4d4f;">¥{{ text ? Number(text).toFixed(2) : '0.00' }}</span>
                </template>
              </a-table>
            </a-card>
          </td>
        </tr>
      </table>

      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="cancel">关闭</a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import { getSell } from '@/api/order/sell'
import { getCashierOrderDetail } from '@/api/retail/order'

export default {
  name: 'OrderDetail',
  components: {},
  data() {
    return {
      record: {
        id: null,
        orderItemList: []
      },
      open: false,
      previewImageVisible: false,
      previewUrl: false,
      goodsColumns: [
        {
          title: '商品条码',
          dataIndex: 'barcode',
          align: 'center',
          customRender: (text) => text || '-'
        },
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          align: 'center'
        },
        {
          title: '商品主图',
          dataIndex: 'picture',
          scopedSlots: { customRender: 'picture' },
          align: 'center'
        },
        {
          title: '规格名称',
          dataIndex: 'skuName',
          align: 'center'
        },

        {
          title: '商品数量',
          dataIndex: 'goodsCount',
          align: 'center'
        },
        {
          title: '已退数量',
          dataIndex: 'refundedCount',
          align: 'center',
          customRender: (text) => text || 0
        },
        {
          title: '商品单价',
          dataIndex: 'price',
          align: 'center',
          customRender: (text) => `¥${text ? Number(text).toFixed(2) : '0.00'}`
        },
        {
          title: '售后状态',
          dataIndex: 'refundStatus',
          align: 'center',
          scopedSlots: { customRender: 'refundStatus' }
        },
        {
          title: '售后金额',
          dataIndex: 'refundAmount',
          align: 'center',
          scopedSlots: { customRender: 'refundAmount' }
        }
      ]
    }
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.record = {
        id: null,
        orderItemList: []
      }
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    getRefundStatusColor(status) {
      const colorMap = {
        5010: 'orange',  // 待审核
        5020: 'blue',   // 待寄回
        5030: 'cyan',   // 买家发货
        5048: 'purple', // 退款处理中
        5050: 'green',  // 退款完成
        5060: 'red',    // 卖家拒绝
        5070: 'gray'    // 售后关闭
      }
      return colorMap[status] || 'default'
    },
    getRefundStatusName(status) {
      const nameMap = {
        5010: '待审核',
        5020: '待寄回',
        5030: '买家发货',
        5048: '退款处理中',
        5050: '退款完成',
        5060: '卖家拒绝',
        5070: '售后关闭'
      }
      return nameMap[status] || '-'
    },
    handleDetail(id) {
      this.reset()
      // 使用 getSell 接口获取订单详情
      getSell({ id: id }).then(response => {
        if (response.code == 20001 && response.data) {
          this.record = response.data
          this.open = true
        } else {
          this.$message.error('获取订单详情失败')
        }
      }).catch(error => {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  margin-bottom: 16px;
}
.order-info {
  .info-table {
    width: 100%;
    border-collapse: collapse;
    tr {
      td {
        padding: 8px 12px;
        border-bottom: 1px solid #e8e8e8;
      }
      td.first {
        background-color: #fafafa;
        font-weight: 500;
        width: 120px;
        text-align: right;
      }
      td.data {
        width: 180px;
      }
    }
  }
}
.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  left: 0;
  z-index: 1;
}
</style>
